import './js/API-service';

import './js/header';
import './js/sponsors-list';
import './js/book-categories';
import './js/bestsellers';
import './js/book-categories-rendering';

import './js/modal-book-card';
import './js/modal-login-form';
import './js/modal-mobile-menu';


import './js/toggleTheme';
import './js/scrollBtn';

import './js/service-firebase';

import './js/notificationsNotiflix';
import './js/auth';
import './js/settings';